let itemsList = [];
let selectedList = [];

function selectPush(e) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
  event: 'select_item',
  ecommerce: {
      items: [{
        item_name: jQuery(e.target).closest('.grid__item').find('.itemName').text(),
        price: jQuery(e.target).closest('.grid__item').find('.itemPrice').text(),
        item_id: jQuery(e.target).closest('.grid__item').find('.itemId').text(),
        item_category: jQuery('#CollectionAjaxContent .itemCat').text().trim(),
        index: 1
      }]
  }
  });
}

document.addEventListener("DOMContentLoaded", (event) => {


var waitForJQuery = setInterval(function () {
    if (typeof $ != 'undefined') {

    // datalayer view_item_list
    jQuery('#CollectionAjaxContent .grid__item.grid-product').each(function (listIndex, el) {
        let productCat = jQuery(el).find('.itemCat').text().trim();
        let productName = jQuery(el).find('.itemName').text().trim();
        let productId =  jQuery(el).find('.itemId').text().trim();
        let productPrice = jQuery(el).find('.itemPrice').text().trim();
        itemsList.push({
            item_name: productName,
            item_id: productId,
            price: productPrice,
            item_category: jQuery('#CollectionAjaxContent .itemCat').text().trim(),
            index: listIndex
        })
    })

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            items: itemsList
        }
    });   

    // dalayer select_item
    jQuery('#CollectionAjaxContent .grid__item a').click(function (e) {
        let selectedName = jQuery(e.target).closest('.grid__item').find('.grid-product__title').text().trim();
        selectPush(e)          
    })
        clearInterval(waitForJQuery);
    }
}, 10);

  });



